import React from 'react';

import {maybePluralize} from '../../util/uihelpers';
import {WBAgentDisclosure} from './WBAgentDisclosure';

export const WBAgentToolGroup: React.FC<
  React.PropsWithChildren<{
    startIndex: number;
    endIndex: number;
  }>
> = ({startIndex, endIndex, children}) => {
  const count = endIndex - startIndex + 1;
  return (
    <WBAgentDisclosure
      icon="wrench"
      label={maybePluralize(count, 'tool call')}
      defaultExpanded={true}>
      <div className="flex flex-col gap-8">{children}</div>
    </WBAgentDisclosure>
  );
};
